var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 275.4 261.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -110.25,
    y1: 121.46,
    x2: 86.6,
    y2: 339.03,
    gradientTransform: "matrix(0.65, 0.65, -0.65, 0.65, 241.32, -12.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da1c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662d91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 114.87,
    y1: 108.34,
    x2: 165.1,
    y2: 186.6,
    gradientTransform: "matrix(0.99, 0.12, -0.13, 1.01, 32.63, -46.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fffcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.41,4.15V176A86.21,86.21,0,0,1,0,176V4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.05,175s-4.44-128,83.47-165.62S272,59.55,272,59.55s23.93,66.74-56,64.93S72.22,261.7,72.22,261.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b289d7401305eb3f85d9ff6b7001d60.svg";
export { ForwardRef as ReactComponent };